<div class="alib">

  <!-- ── Header ───────────────────────────────────────────────── -->
  <header class="alib__header">
    <div>
      <h1 class="alib__title">
        <i class="fa-solid fa-book-open alib__title-icon"></i>
        {{ 'LIBRARY.ADMIN.TITLE' | translate }}
      </h1>
      <p class="alib__subtitle">{{ 'LIBRARY.ADMIN.SUBTITLE' | translate }}</p>
    </div>
    <span class="alib__count" *ngIf="!loading()">
      {{ 'LIBRARY.COUNT' | translate:{ count: filtered().length } }}
    </span>
  </header>

  <!-- ── Filtres : listes du référentiel, plus aucun ID à saisir ── -->
  <section class="alib__filter-panel">
    <label class="alib__filter">
      <span class="alib__filter-label">{{ 'LIBRARY.ADMIN.BY_PROFESSOR' | translate }}</span>
      <select [(ngModel)]="filterProfessorId" (ngModelChange)="applyFilters()">
        <option [ngValue]="null">{{ 'ADMIN_CALENDAR.ALL_PROFESSORS' | translate }}</option>
        <option *ngFor="let p of options().professors" [ngValue]="p.id">{{ p.fullName }}</option>
      </select>
    </label>

    <label class="alib__filter">
      <span class="alib__filter-label">{{ 'LIBRARY.ADMIN.BY_SUBJECT' | translate }}</span>
      <select [(ngModel)]="filterSubjectId" (ngModelChange)="applyFilters()">
        <option [ngValue]="null">{{ 'CALENDAR.FILTER.ALL_SUBJECTS' | translate }}</option>
        <ng-container *ngFor="let g of subjectGroups()">
          <optgroup [label]="g.pathLabel || ('CALENDAR.CREATE.NO_PATH' | translate)">
            <option *ngFor="let s of g.subjects" [ngValue]="s.id">{{ subjectLabel(s) }}</option>
          </optgroup>
        </ng-container>
      </select>
    </label>

    <label class="alib__filter">
      <span class="alib__filter-label">{{ 'CALENDAR.FILTER.GROUP' | translate }}</span>
      <select [(ngModel)]="filterGroupId" (ngModelChange)="applyFilters()">
        <option [ngValue]="null">{{ 'CALENDAR.FILTER.ALL_GROUPS' | translate }}</option>
        <option *ngFor="let g of options().groups" [ngValue]="g.id">{{ g.name }}</option>
      </select>
    </label>

    <!-- La case « inclure les archives » ne repondait qu'a la moitie de la
         question : elle montrait les archives sans jamais permettre de les
         isoler, ni de retrouver ce qui attend une publication. -->
    <label class="alib__filter">
      <span class="alib__filter-label">{{ 'LIBRARY.STATUS.LABEL' | translate }}</span>
      <select [ngModel]="statusFilter()" (ngModelChange)="setStatus($event)">
        <option value="ALL">{{ 'LIBRARY.STATUS.ALL' | translate }}</option>
        <option value="published">{{ 'LIBRARY.STATUS.PUBLISHED' | translate }}</option>
        <option value="unpublished">{{ 'LIBRARY.STATUS.UNPUBLISHED' | translate }}</option>
        <option value="archived">{{ 'LIBRARY.STATUS.ARCHIVED' | translate }}</option>
      </select>
    </label>

    <button *ngIf="hasFilters" class="alib__clear" type="button" (click)="clearFilters()">
      <i class="fa-solid fa-xmark"></i>
      {{ 'CALENDAR.FILTER.CLEAR' | translate }}
    </button>
  </section>

  <!-- ── Category chips ───────────────────────────────────────── -->
  <nav class="alib__chips" *ngIf="!loading()">
    <button *ngFor="let f of categoryFilters"
            class="alib__chip" type="button"
            [class.is-active]="selectedCategory() === f.key"
            (click)="setCategory(f.key)">
      <i [class]="f.icon"></i>
      {{ f.i18nKey | translate }}
    </button>
  </nav>

  <!-- ── Search ───────────────────────────────────────────────── -->
  <div class="alib__search" *ngIf="!loading()">
    <i class="fa-solid fa-magnifying-glass"></i>
    <input type="search"
           [value]="query()"
           (input)="onQueryInput($any($event.target).value)"
           [placeholder]="'LIBRARY.SEARCH_PLACEHOLDER' | translate">
  </div>

  <!-- ── Loading skeleton ─────────────────────────────────────── -->
  <div *ngIf="loading()" class="alib__skeleton">
    <div class="alib__skel-row" *ngFor="let _ of [1,2,3]"></div>
  </div>

  <!-- ── Error : jamais de supports de substitution ────────────── -->
  <app-error-state *ngIf="!loading() && errored()"
                   titleKey="LIBRARY.ERROR_TITLE"
                   messageKey="LIBRARY.LOAD_ERROR"
                   (retry)="reload()"></app-error-state>

  <!-- ── Results ──────────────────────────────────────────────── -->
  <ng-container *ngIf="!loading() && !errored()">
    <div class="alib__list" *ngIf="filtered().length > 0; else emptyTpl">
      <div class="alib__item" *ngFor="let m of filtered()">
        <app-course-material-card
          [material]="m"
          (download)="onDownload($event)"
          (preview)="previewTarget.set($event)"
          (openExternal)="onOpenExternal($event)">
        </app-course-material-card>
        <!-- Le back refuse déjà ces verbes sans `library.write.own`. Les
             masquer n'est donc pas la protection — c'est l'honnêteté de
             l'écran : ne pas proposer ce qui sera refusé. -->
        @if (canWrite) {
        <div class="alib__item-actions">
          <!-- Un support archive ne se modifie ni ne se rearchive : il se
               remet en circulation, ou rien. -->
          @if (m.isArchived) {
            <button class="alib__act-btn alib__act-btn--restore" type="button"
                    (click)="unarchive(m)"
                    [title]="'LIBRARY.UNARCHIVE' | translate">
              <i class="fa-solid fa-box-open"></i>
            </button>
          } @else {
            <button class="alib__act-btn alib__act-btn--edit" type="button" (click)="openEdit(m)"
                    [title]="'COMMON.EDIT' | translate">
              <i class="fa-solid fa-pen"></i>
            </button>
            <button class="alib__act-btn alib__act-btn--del" type="button" (click)="openDelete(m)"
                    [title]="'COMMON.DELETE' | translate">
              <i class="fa-solid fa-trash"></i>
            </button>
          }
        </div>
        }
      </div>
    </div>

    <ng-template #emptyTpl>
      <div class="alib__empty">
        <div class="alib__empty-icon"><i class="fa-solid fa-folder-open"></i></div>
        <!-- « Aucun support » et « aucun support pour ce filtre » ne sont pas
             la même nouvelle : la seconde ne se dit que si un filtre est posé. -->
        <h3>{{ 'LIBRARY.EMPTY_TITLE' | translate }}</h3>
        @if (hasFilters) {
          <p>{{ 'LIBRARY.ADMIN.EMPTY_DESC' | translate }}</p>
        }
      </div>
    </ng-template>
  </ng-container>

</div>

<!-- ════════════════════════════════════════════════════════════
     EDIT MODAL
════════════════════════════════════════════════════════════ -->
<div class="lib-modal-backdrop" *ngIf="editOpen()" (click)="closeEdit()"></div>
<aside class="lib-modal" *ngIf="editOpen()">
  <header class="modal__head">
    <h2 class="modal__title">{{ 'LIBRARY.EDIT.TITLE' | translate }}</h2>
    <button class="modal__close" type="button" (click)="closeEdit()">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </header>
  <form class="modal__body" (ngSubmit)="submitEdit()">
    <div class="form-field">
      <label>{{ 'LIBRARY.UPLOAD.FORM.TITLE' | translate }} *</label>
      <input type="text" [(ngModel)]="editForm.title" name="title" required>
    </div>
    <div class="form-field">
      <label>{{ 'LIBRARY.UPLOAD.FORM.DESCRIPTION' | translate }}</label>
      <textarea [(ngModel)]="editForm.description" name="description" rows="3"></textarea>
    </div>
    <label class="form-check">
      <input type="checkbox" [(ngModel)]="editForm.isPublic" name="isPublic">
      {{ 'LIBRARY.UPLOAD.FORM.IS_PUBLIC' | translate }}
    </label>
    <footer class="modal__foot">
      <button type="button" class="btn-secondary" (click)="closeEdit()" [disabled]="saving()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button type="submit" class="btn-primary" [disabled]="saving()">
        <i class="fa-solid fa-spinner fa-spin" *ngIf="saving()"></i>
        {{ 'COMMON.SAVE' | translate }}
      </button>
    </footer>
  </form>
</aside>

<!-- ════════════════════════════════════════════════════════════
     DELETE CONFIRM
════════════════════════════════════════════════════════════ -->
<div class="lib-modal-backdrop" *ngIf="deleteTarget()" (click)="cancelDelete()"></div>
<aside class="lib-modal lib-modal--sm" *ngIf="deleteTarget()">
  <header class="modal__head">
    <h2 class="modal__title">{{ 'COMMON.DELETE' | translate }}</h2>
  </header>
  <div class="modal__body">
    <p>{{ 'LIBRARY.ADMIN.CONFIRM_DELETE' | translate:{ title: deleteTarget()!.title } }}</p>
    <footer class="modal__foot">
      <button type="button" class="btn-secondary" (click)="cancelDelete()" [disabled]="deleting()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button type="button" class="btn-danger" (click)="confirmDelete()" [disabled]="deleting()">
        <i class="fa-solid fa-spinner fa-spin" *ngIf="deleting()"></i>
        {{ 'COMMON.DELETE' | translate }}
      </button>
    </footer>
  </div>
</aside>

<!-- Aperçu : le flux passe par l'endpoint administration, qui exige le jeton. -->
<app-material-preview
  [material]="previewTarget()"
  [download]="downloadFn"
  (closed)="previewTarget.set(null)"></app-material-preview>
